import { useState, useEffect, useRef } from 'react';

export const useTypewriter = (text: string, isActive: boolean, duration: number = 2000) => {
  const [displayText, setDisplayText] = useState('');
  const [isTyping, setIsTyping] = useState(false);
  const startTimeRef = useRef<number>(0);
  const animationFrameRef = useRef<number>(0);

  useEffect(() => {
    if (!isActive || !text) {
      setDisplayText(text);
      setIsTyping(false);
      return;
    }

    setIsTyping(true);
    setDisplayText('');
    startTimeRef.current = Date.now();

    const animate = () => {
      const elapsed = Date.now() - startTimeRef.current;
      const progress = Math.min(elapsed / duration, 1); // Ensure we don't exceed 1

      // Calculate how many characters should be shown based on progress
      const totalChars = text.length;
      const charsToShow = Math.floor(progress * totalChars);

      setDisplayText(text.slice(0, charsToShow));

      if (progress < 1) {
        animationFrameRef.current = requestAnimationFrame(animate);
      } else {
        setIsTyping(false);
      }
    };

    animationFrameRef.current = requestAnimationFrame(animate);

    return () => {
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current);
      }
    };
  }, [text, isActive, duration]);

  return { displayText, isTyping };
};